import React from 'react';
import { Paper, Box, Typography, Alert, AlertTitle } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const steps = [
  { value: 0, label: '기본 정보', color: 'info' },
  { value: 1, label: '파일 관리', color: 'error' },
  { value: 2, label: '담당자 관리', color: 'success' },
  { value: 3, label: '공급제품 가격 관리', color: 'secondary' },
];

const PartnerAddGuideInfo = () => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Paper sx={{ my: 1, p: 1 }} variant="outlined">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          px: 2,
          py: 1,
          '& *': {
            mx: 1,
          },
          backgroundColor: '#424242',
          color: '#fff',
        }}
      >
        <InfoIcon />
        <Typography variant="subtitle2" component="div">
          거래처 가이드
        </Typography>
        <Typography variant="body2" component="div">
          거래처 관리 가이드
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
          '& *': {
            mx: 1,
          },
        }}
      >
        {activeStep === 0 && (
          <>
            <Alert severity="info">
              <AlertTitle>기본 정보</AlertTitle>
              <Typography variant="body2" component="div">
                기본 정보 폼을 입력하세요.
              </Typography>
            </Alert>
            <Box>
              <Typography variant="body2" component="div">
                거래처 종류, 거래처명, 사업자번호, 산업체 유형, 연락처 주소를 선택 및 입력하세요.
              </Typography>
            </Box>
          </>
        )}
        {activeStep === 1 && (
          <>
            <Alert severity="error">
              <AlertTitle>파일 관리</AlertTitle>
              <Typography variant="body2" component="div">
                거래처 관련 파일을 업로드하세요.
              </Typography>
            </Alert>
            <Box>
              <Typography variant="body2" component="div">
                사업자등록증을 업로드하세요
              </Typography>
              <Typography variant="body2" component="div">
                통장사본을 업로드하세요
              </Typography>
              <Typography variant="body2" component="div">
                신용평가서를 업로드하세요
              </Typography>
            </Box>
          </>
        )}
        {activeStep === 2 && (
          <>
            <Alert severity="success">
              <AlertTitle>담당자 관리</AlertTitle>
              <Typography variant="body2" component="div">
                거래처 담당자 정보를 관리하세요.
              </Typography>
            </Alert>
            <Box>
              <Typography variant="body2" component="div">
                담당자명을 등록하세요
              </Typography>
              <Typography variant="body2" component="div">
                담당자 연락처 정보를 등록하세요
              </Typography>
            </Box>
          </>
        )}
        {activeStep === 3 && (
          <>
            <Alert severity="secondary">
              <AlertTitle>공급제품 가격관리</AlertTitle>
              <Typography variant="body2" component="div">
                거래처 공급제품의 가격을 관리합니다.
              </Typography>
            </Alert>
            <Box>
              <Typography variant="body2" component="div">
                제품마스터정보에서 제품을 선택하세요
              </Typography>
              <Typography variant="body2" component="div">
                가격타입을 선택하세요
              </Typography>
              <Typography variant="body2" component="div">
                가격을 입력하세요
              </Typography>
              <Typography variant="body2" component="div">
                가격 사양 설명을 입력하세요
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <MobileStepper
        variant="dots"
        steps={steps.length}
        position="static"
        activeStep={activeStep}
        sx={{ flexGrow: 1, borderTop: 1, borderColor: 'divider' }}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === 3}>
            {steps[activeStep + 1]?.label}
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            뒤로
          </Button>
        }
      />
    </Paper>
  );
};

export default PartnerAddGuideInfo;
